module.exports = __webpack_public_path__ + "img/44.1.00839cfa.jpg";